import React, { Component } from 'react';
import NavBar from '../../components/shared/NavBar';
import connect from 'react-redux/lib/connect/connect';
import { actions } from '../../config/reduxIndex';
import { getHeaderRoutes } from '../../config/routeConfig';
import { cookie } from '../../utilities/Utility';

/**
 * @props globalState - redux -> state.globalSTate
 * @props dispatchConfig - redux -> state.dispatchConfig
 * @props {function} logout - redux -> login.logout()
 * @props {function} routeTrigger - redux -> routing.routeTrigger()
 * @returns DispatchPageControlContainer or NavBar or Redirect
 */
class NavBarContainer extends Component {
	state = {
		subRoutesOpen: false
	}

	render() {
		return this.navBar();
	}

	navBar = () => {
		let dispatchUserType = cookie.get('userType');
		const headerRoutes = getHeaderRoutes(dispatchUserType);
		const currentRoute = this.currentRoute();
		const { pageLoading, pageSaving } = this.props.globalState;

		return <NavBar
			currentRoute={currentRoute}
			pageLoading={pageLoading}
			pageSaving={pageSaving}
			mainRoutes={headerRoutes.mainRoutes}
			subRoutes={headerRoutes.subRoutes}
			subRoutesOpen={this.state.subRoutesOpen}
			toggleSubRoute={this.toggleSubRoute}
			logout={this.logout}
			pageControls={this.pageControlsSwitch()}
			setRoute={this.setRoute}
		/>;
	}

	setRoute = (routeName) => (e) => {
		const { routeTrigger } = this.props;
		routeTrigger(routeName);
	}

	pageControlsSwitch = () => {
		const currentRoute = this.currentRoute();
		const { match, } = this.props;
		const { setRoute } = this;
		let params;
		switch (currentRoute) {
			default:
				return null;
		}
	}

	currentRoute = () => {
		return this.props.match.url.split('/')[1];
	}

	toggleSubRoute = () => {
		this.setState({ subRoutesOpen: !this.state.subRoutesOpen });
	}
}

function mapStateToProps(state) {
	return {
		globalState: state.globalState,
		dispatchConfig: state.dispatchConfig
	};
}

const mapDispatchToProps = dispatch => {
	return {
		logout: () => {
			dispatch(actions.login.logout());
		},
		routeTrigger: (routeName) => {
			dispatch(actions.routing.routeTrigger(routeName));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBarContainer);	


// WEBPACK FOOTER //
// ./src/containers/shared/NavBarContainer.js